<template>
  <div class="bg-white p-4">
    <GetAppTable ref="getMedi" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import _ from "lodash";
import GetAppTable from "./components/getAppTable.vue";
export default {
  components: {
    GetAppTable,
  },
  data() {
    return {};
  },
  methods: {},
  async mounted() {
    // await this.$store.dispatch("services/getAppForm");
  },
};
</script>

<style>
.modal-header {
  display: flex !important;
  align-items: center !important;
  background-color: #4f0a4b !important;
  border-color: #4f0a4b !important;
  padding: 10px !important;
}

.modal-title {
  font-size: 20px !important;
  color: #fff !important;
}
.form-group {
  margin-bottom: 0.5rem;
}
input.is-invalid ~ .custom-file-label {
  border-color: #cad1d7;
}
.widtht30percent {
  width: 30%;
  height: 140px !important;
}
</style>
